export default function (description) {
	return description.replaceAll('\n', '<br>')
}